import * as Cookies from 'js-cookie';
import { validateActionMetric, formatGaFromPedl, formatGaLegacy, } from './formatEvent';
export const defaultGetCurrentTimestamp = () => new Date().toISOString();
export const defaultGetPageId = () => null;
export const defaultGetSessionId = () => {
    const withTimestamp = Cookies.get('bsid');
    if (typeof withTimestamp === 'string') {
        return withTimestamp.split('_')[0];
    }
    else {
        return null;
    }
};
export const defaultGetTrackingId = () => Cookies.get('firstTimeVisitor') || null;
export const defaultGetUserAgent = () => typeof window !== 'undefined' && window.navigator
    ? window.navigator.userAgent
    : null;
const batchedMetrics = {};
export const defaultSend = (metric) => {
    // do not send if in server
    if (typeof window === 'undefined') {
        return;
    }
    validateActionMetric(metric);
    // -----------------------------------------------------------
    // SEND THE METRIC TO GA
    // Format the metric with legacy rules:
    const fieldsObjectLegacy = formatGaLegacy(metric);
    // Format the metric with data from PEDL fields
    const fieldsObjectFromPedl = formatGaFromPedl(metric);
    if (typeof ga === 'function') {
        // send both metrics
        ga('send', fieldsObjectLegacy);
        ga('send', fieldsObjectFromPedl);
    }
    // -----------------------------------------------------------
    // SEND THE METRIC TO PEDL
    // Add the metric to batched metrics cache
    const metricKey = metric.BusinessUnit || 'metric-without-business-unit';
    if (batchedMetrics[metricKey]) {
        batchedMetrics[metricKey].push(metric);
    }
    else {
        batchedMetrics[metricKey] = [metric];
    }
    /*
    * Add metric to queue to be sent in batches. Uses the 'idle until
    * urgent' pattern: https://philipwalton.com/articles/idle-until-urgent/
    *
    * This will make sure events will only be sent when the application
    * is idle, at the same time guaranteeing that they will be sent
    * before page unload
    */
    const windowWithDefinedProperties = window;
    if (typeof windowWithDefinedProperties.requestIdleCallback === 'function') {
        windowWithDefinedProperties.requestIdleCallback(sendMetricsInQueue);
    }
    else {
        window.setTimeout(sendMetricsInQueue, 1);
    }
};
function sendMetricsInQueue() {
    for (let businessUnit in batchedMetrics) {
        if (batchedMetrics.hasOwnProperty(businessUnit)) {
            // gather events from queue
            const eventGroup = batchedMetrics[businessUnit];
            // do not send if there are no items to be sent
            if (eventGroup.length <= 0) {
                return;
            }
            // clean queue
            batchedMetrics[businessUnit] = [];
            // group the events together in the EventData array
            const eventData = eventGroup
                .map(event => event.EventData)
                .reduce((prev, curr) => prev.concat(curr), []);
            const body = Object.assign({}, eventGroup[0], { EventData: eventData });
            logForTestingPurpose(body);
            const pedlEndpoint = process.env.PEDL_ENDPOINT || '/eventslogging/v1/event';
            if (process.env.NODE_ENV !== 'test') {
                fetch(pedlEndpoint, {
                    method: 'post',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(body),
                });
            }
        }
    }
}
// SEND ALL EVENTS BEFORE UNLOAD:
if (typeof window !== 'undefined') {
    const windowWithDefinedProperties = window;
    // adapted from https://github.com/GoogleChromeLabs/idlize/blob/master/IdleQueue.mjs#L24
    const isSafari = !!(typeof windowWithDefinedProperties.safari === 'object' &&
        windowWithDefinedProperties.safari.pushNotification);
    if (isSafari) {
        window.addEventListener('beforeunload', sendMetricsInQueue);
    }
    else {
        window.addEventListener('visibilitychange', sendMetricsInQueue);
    }
}
function logForTestingPurpose(metric) {
    const windowWithDefinedProperties = window;
    try {
        if (windowWithDefinedProperties && !windowWithDefinedProperties.pedl) {
            windowWithDefinedProperties.pedl = () => { };
        }
        if (windowWithDefinedProperties && windowWithDefinedProperties.pedl) {
            windowWithDefinedProperties.pedl(metric);
        }
    }
    catch (e) { }
}
